import axios from "axios";
import { saveAs } from "file-saver";
import { PROYECT } from "services/api";
import { getErrorBlob } from "helpers/extractError";
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";
import {
  TRANSFER_INVOICE_REPORT_LOADINGS,
  reportTransferInvoiceTypes,
} from "redux/reducers/Reports/reportTransferInvoice/types";

const { SET_TRANSFER_INVOICE_REPORT_FILTERS } = reportTransferInvoiceTypes;
const { GET_REPORT } = TRANSFER_INVOICE_REPORT_LOADINGS;

export const getTransferInvoiceReportAction = (
  { startDate, endDate, station, isPdf }
) => async (dispatch, getState) => {
  const token = getState().login.token || localStorage.getItem("crm-user");
  const params = {
    start: startDate,
    end: endDate,
    idStation: station.id,
    pdf: isPdf,
  };
  dispatch(startRequestComp(GET_REPORT));
  try {
    const url = `${process.env.REACT_APP_URL}${PROYECT}/invoices/transfer/report`;
    const res = await axios.get(url, {
      headers: { authorization: token },
      responseType: "blob",
      params,
    });

    const format = isPdf ? "pdf" : "xlsx";
    saveAs(res.data, `Reporte_facturas_traslado_${station.name}_${startDate}_${endDate}.${format}`);
    dispatch(setSnackbar("Reporte descargado con éxito", "success"));
  } catch (err) {
    dispatch(setSnackbar(await getErrorBlob(err)));
  } finally {
    dispatch(stopRequestComp(GET_REPORT));
  }
};

export const setTransferInvoiceReportFilters = (key = "", value) => ({
  type: SET_TRANSFER_INVOICE_REPORT_FILTERS,
  payload: { key, value }
});
